import React from 'react';

interface ToggleButtonProps {
  isToggled: boolean;
  onToggle: () => void;
  leftLabel: string;
  rightLabel: string;
}

export default function ToggleButton({ isToggled, onToggle, leftLabel, rightLabel }: ToggleButtonProps) {
  return (
    <div className="flex justify-center items-center gap-4">
      <span className={`text-lg ${!isToggled ? 'text-green-600 font-bold' : 'text-gray-600'}`}>
        {leftLabel}
      </span>
      <button 
        onClick={onToggle}
        className="relative w-16 h-8 rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-green-600 focus:ring-offset-2"
        style={{
          backgroundColor: '#059669',
          transition: 'background-color 0.3s'
        }}
        aria-pressed={isToggled}
      >
        <span 
          className="absolute w-6 h-6 bg-white rounded-full shadow-md transform transition-transform duration-300"
          style={{
            top: '4px',
            left: isToggled ? '4px' : 'calc(100% - 28px)'
          }}
        />
      </button>
      <span className={`text-lg ${isToggled ? 'text-green-600 font-bold' : 'text-gray-600'}`}>
        {rightLabel}
      </span>
    </div>
  );
}